export default {
  cta: {
    primary: 'Get service',
    secondary: 'Learn more'
  },
  list_page: {
    title: 'Zakelijke diensten',
    subtitle:
      'Regel hier zaken die nodig zijn om jouw bedrijf te runnen en te beschermen.'
  },
  details_page: {
    go_back: 'Terug naar zakelijke diensten',
    title: 'DGA salary administration',
    empty_state: {
      title: 'No image available',
      subtitle: 'The team will soon upload an image for this service'
    }
  },
  breadcrumb: {
    business_services: 'Business services',
    dga: 'DGA',
    tax: 'TAX'
  }
};
